<template>
    <div class="component-play-show" :style="{'border-radius': type=='pc'?'32px':'16px'}">
        <div class="video-title"
            :style="{'height':type=='pc'?'56px':'40px','padding-left':type=='pc'?'26px':'14px'}"
        >
            <img
                :style="{'height':type=='pc'?'20px':'18px','width':type=='pc'?'20px':'18px'}"
                src="https://p1.ssl.qhimg.com/t110b9a93010010ae4360e8b07f.png"
                alt=""
            >
            <span :style="{'font-size':type=='pc'?'16px':'14px'}">{{data.title}}</span>
        </div>
        <div class="module-video" :style="{'border-radius': type=='pc'?'32px':'16px'}">
            <video v-if="videoType=='m3u8'" :poster="data.imgurl" ref="videoPlayer" width="100%" height="100%" controls></video>
            <video v-else :poster="data.imgurl" width="100%" height="100%" controls preload="metadata">
                <source :src="data.hlsUrl" type="video/mp4">
            </video>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Hls from 'hls.js'

const props = defineProps({
    data: {
        type: Object,
        default: {}
    },
    type: {
        type: String,
        default: 'pc'
    }
})

let videoType = ref('m3u8')
let videoPlayer = ref(null)
onMounted(() => {
    if(props.data.hlsUrl){
        if(props.data.hlsUrl.split('.').slice(-1)[0]=='m3u8'){
            videoType.value = 'm3u8'
            const video = videoPlayer.value;
            if (Hls.isSupported()) {
                const hls = new Hls();
                hls.loadSource(props.data.hlsUrl); // 替换成你的视频路径
                hls.attachMedia(video);
            } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = props.data.hlsUrl; // 替换成你的视频路径
                //切换自动播放
                // video.addEventListener('loadedmetadata', function() {
                // video.play();
                // });
            }
        }else{
            videoType.value = 'mp4'
        }
    }
})

</script>

<style lang="scss" scoped>
.component-play-show {
    width: 100%;
    height: 100%;
    background: #ffffff;
    display: flex;
    // border-radius: 32px;
    overflow: hidden;
    flex-direction: column;
    justify-content: space-between;
    .video-title{
        display: flex;
        align-items: center;
        img{
            // height: 20px;
            // width: 20px;
        }
        span{
            font-size: 16px;
            font-weight: 600;
            color: #3D3D3D;
            margin-left: 10px;
        }
    }
    .module-video{
        flex: 1;
        display: flex;
        align-items: center;
        // border-radius: 32px;
        overflow: hidden;
    }
}
</style>